import React from 'react';

interface SocialShareButtonsProps {
  shareUrl: string;
  shareText: string;
  className?: string;
  iconSize?: string;
}

const SocialShareButtons: React.FC<SocialShareButtonsProps> = ({
  shareUrl,
  shareText,
  className = '',
  iconSize = 'h-4 w-4',
}) => {
  const encodedShareUrl = encodeURIComponent(shareUrl);
  const encodedShareText = encodeURIComponent(shareText);

  const socialLinks = [
    { name: 'Facebook', iconUrl: 'https://assets.esoteric.pl/img/icons/assets_icons_facebook.svg', shareUrl: `https://www.facebook.com/sharer/sharer.php?u=${encodedShareUrl}` },
    { name: 'X', iconUrl: 'https://assets.esoteric.pl/img/icons/assets_icons_x.svg', shareUrl: `https://twitter.com/intent/tweet?url=${encodedShareUrl}&text=${encodedShareText}` },
    { name: 'Pinterest', iconUrl: 'https://assets.esoteric.pl/img/icons/assets_icons_pinterest.svg', shareUrl: `https://pinterest.com/pin/create/button/?url=${encodedShareUrl}&description=${encodedShareText}` },
    { name: 'WhatsApp', iconUrl: 'https://assets.esoteric.pl/img/icons/assets_icons_whatsapp.svg', shareUrl: `https://api.whatsapp.com/send?text=${encodedShareText}%20${encodedShareUrl}` },
    { name: 'Telegram', iconUrl: 'https://assets.esoteric.pl/img/icons/assets_icons_telegram.svg', shareUrl: `https://t.me/share/url?url=${encodedShareUrl}&text=${encodedShareText}` },
    { name: 'Messenger', iconUrl: 'https://assets.esoteric.pl/img/icons/assets_icons_messenger.svg', shareUrl: `fb-messenger://share/?link=${encodedShareUrl}` },
    { name: 'iMessage', iconUrl: 'https://assets.esoteric.pl/img/icons/assets_icons_imessage.svg', shareUrl: `sms:?&body=${encodedShareText}%20${encodedShareUrl}` },
  ];

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {socialLinks.map((social) => (
        <a
          key={social.name}
          href={social.shareUrl}
          aria-label={`Udostępnij na ${social.name}`}
          target="_blank"
          rel="noopener noreferrer"
          className="opacity-70 hover:opacity-100 transition-opacity"
        >
          <img src={social.iconUrl} alt={social.name} className={iconSize} style={{ filter: 'invert(1)' }} />
        </a>
      ))}
    </div>
  );
};

export default SocialShareButtons;
